import { ChevronLeft, ChevronRight, Download, Share2, X } from "lucide-react";
import { useEffect, useState } from "react";
import type { MediaItem } from "../types";

interface Props {
  item: MediaItem;
  initialIndex?: number;
  onClose: () => void;
}

export function Lightbox({ item, initialIndex = 0, onClose }: Props) {
  const [index, setIndex] = useState(initialIndex);
  const asset = item.assets[index];

  useEffect(() => {
    const keydown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
      if (event.key === "ArrowLeft") setIndex((value) => (value - 1 + item.assets.length) % item.assets.length);
      if (event.key === "ArrowRight") setIndex((value) => (value + 1) % item.assets.length);
    };
    document.addEventListener("keydown", keydown);
    document.body.classList.add("modal-open");
    return () => {
      document.removeEventListener("keydown", keydown);
      document.body.classList.remove("modal-open");
    };
  }, [item.assets.length, onClose]);

  const share = async () => {
    if (navigator.share) await navigator.share({ title: item.title, url: window.location.href });
    else await navigator.clipboard.writeText(window.location.href);
  };

  if (!asset) return null;
  return (
    <div className="lightbox" role="dialog" aria-modal="true" aria-label={item.title} onClick={onClose}>
      <button className="lightbox-close" onClick={onClose} aria-label="关闭"><X /></button>
      <div className="lightbox-stage" onClick={(event) => event.stopPropagation()}>
        {asset.mimeType.startsWith("video/") ? (
          <video key={asset.id} src={asset.url} controls autoPlay playsInline />
        ) : (
          <img key={asset.id} src={asset.url} alt={item.title} />
        )}
        {item.assets.length > 1 && (
          <>
            <button className="lightbox-nav prev" onClick={() => setIndex((index - 1 + item.assets.length) % item.assets.length)} aria-label="上一张"><ChevronLeft /></button>
            <button className="lightbox-nav next" onClick={() => setIndex((index + 1) % item.assets.length)} aria-label="下一张"><ChevronRight /></button>
          </>
        )}
      </div>
      <div className="lightbox-bar" onClick={(event) => event.stopPropagation()}>
        <div><strong>{item.title}</strong><span>{index + 1} / {item.assets.length}</span></div>
        <div className="lightbox-actions">
          <button onClick={share}><Share2 size={18} /> 分享</button>
          <a href={asset.downloadUrl}><Download size={18} /> 保存{asset.mimeType.startsWith("image/") ? "原图" : "视频"}</a>
        </div>
      </div>
    </div>
  );
}
